export default __webpack_public_path__ + "static/media/Common.677a5b3e.svg";